import { observer } from "mobx-react-lite";
import { useEffectOnMount } from "@/domains/react/useEffectOnMount";
import { TrackedEvent, TrackedEventContext, trackEvent } from "@/domains/metrics";
import { ImportDropTarget } from "@/components/importing";

interface Props {
  isDragging: boolean;
}

export const NotesListPageListEmpty = observer<Props>(({ isDragging }) => {
  useEffectOnMount(() => {
    trackEvent(TrackedEvent.ImportCtaView, {
      context: TrackedEventContext.Notes,
    });
  });

  return <ImportDropTarget isActive={isDragging} />;
});
